import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShiftValidationDetails } from '@wilson/interfaces';
import { ValidationDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  ShiftTimelineDataState,
  TimelineAssignedShiftValidationsStateService,
  TimelineUnassignedShiftValidationsStateService,
} from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';
@Injectable()
export class ShiftTimelineValidationDataSourceService extends ValidationDataSourceService {
  private store = inject(Store);
  private timelineAssignedShiftValidationsStateService = inject(
    TimelineAssignedShiftValidationsStateService,
  );
  private timelineUnassignedShiftValidationsStateService = inject(
    TimelineUnassignedShiftValidationsStateService,
  );

  override hasShiftValidated(shiftId: string): Observable<boolean> {
    return this.timelineUnassignedShiftValidationsStateService.hasShiftValidated(
      shiftId,
    );
  }

  override isShiftOfUserValidated(
    userId: string,
    shiftStartDate: Date,
  ): Observable<boolean> {
    return this.store.select(
      ShiftTimelineDataState.isShiftValidated(userId, shiftStartDate),
    );
  }

  override isCurrentUserValidationLoading(userId: string): Observable<boolean> {
    return this.store.select(
      ShiftTimelineDataState.isCurrentUserValidationLoading(userId),
    );
  }

  override shiftValidationStreamForAssignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[]> {
    return this.timelineAssignedShiftValidationsStateService.validations(
      shiftId,
    );
  }

  override shiftValidationStreamForUnassignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[]> {
    return this.timelineUnassignedShiftValidationsStateService.validations(
      shiftId,
    );
  }

  override isLoadingValidationsError(): Observable<boolean> {
    return this.store.select(ShiftTimelineDataState.isLoadingValidationsError);
  }

  override isLoadingValidationsV1Error(): Observable<boolean> {
    return this.store.select(
      ShiftTimelineDataState.isLoadingValidationsV1Error,
    );
  }

  override isShiftValidationLoadingForAssignedShifts(
    shiftId: string,
  ): Observable<boolean> {
    return this.timelineAssignedShiftValidationsStateService.isLoading(shiftId);
  }

  override isShiftValidationLoadingForUnassignedShifts(
    shiftId: string,
  ): Observable<boolean> {
    return this.timelineUnassignedShiftValidationsStateService.isLoading(
      shiftId,
    );
  }
}
